module.exports = __webpack_public_path__ + "static/media/personal.aaafb1e3.png";